import DetailsData from 'txp-data/lib/schema/viewSchema/DetailsData';

export default function getDetailsEditableField(detailsData: DetailsData): string {
    if (detailsData && detailsData.thirdLine) {
        return detailsData.thirdLine.text;
    }
    return '';
}
